import axios, { AxiosError } from 'axios';
import { getAuth } from 'firebase/auth';

const API_BASE_URL = process.env.NX_API_URL || 'http://localhost:3000';

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
});

// Request interceptor to add Firebase auth token
axiosInstance.interceptors.request.use(async (config) => {
  try {
    const auth = getAuth();
    const currentUser = auth.currentUser;

    if (currentUser) {
      const idToken = await currentUser.getIdToken();
      config.headers.Authorization = `Bearer ${idToken}`;
    }
  } catch (error) {
    console.error('Failed to get Firebase ID token:', error);
    // Continue with request even if token retrieval fails
  }

  return config;
});

// Response interceptor for error handling
axiosInstance.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    console.error('API Error:', error);
    throw error;
  },
);

const FMSApiClient = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  use: <ApiType>(api: new (...args: any[]) => ApiType): ApiType =>
    new api(undefined, API_BASE_URL, axiosInstance),
};

export { axiosInstance };
export default FMSApiClient;
